import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32.72"
    height="33.391"
    viewBox="0 0 32.72 33.391"
    className={className}
  >
    <g
      id="Group_19763"
      data-name="Group 19763"
      transform="translate(-4052 701.396)"
    >
      <g
        id="Group_19756"
        data-name="Group 19756"
        transform="translate(4052 -686.463)"
      >
        <path
          id="Path_9279"
          data-name="Path 9279"
          d="M-947.586,974.2a3.02,3.02,0,0,0-.414,1.5v14.123a2.814,2.814,0,0,0,.414,1.466l8.544-8.544Z"
          transform="translate(948 -974.2)"
          fill="#ddd"
        />
        <path
          id="Path_9280"
          data-name="Path 9280"
          d="M-925.118,1006.787a4.722,4.722,0,0,1-3.254,1.275,4.6,4.6,0,0,1-3.254-1.275l-2.617-2.487-8.957,8.512a3.1,3.1,0,0,0,1.443.351h26.838a3.2,3.2,0,0,0,1.442-.351l-8.957-8.512Z"
          transform="translate(944.73 -994.704)"
          fill="#ddd"
        />
        <path
          id="Path_9281"
          data-name="Path 9281"
          d="M-869.556,974.2l-8.544,8.544,8.544,8.544a2.814,2.814,0,0,0,.414-1.466V975.7A2.844,2.844,0,0,0-869.556,974.2Z"
          transform="translate(901.862 -974.2)"
          fill="#ddd"
        />
      </g>
      <g
        id="Path_9283"
        data-name="Path 9283"
        transform="translate(4054.55 -701.396)"
        fill="#ddd"
        strokeLinecap="round"
      >
        <path
          d="M 13.4318962097168 24.71607208251953 L 0.5000044107437134 12.653395652771 L 0.5000044107437134 0.4999994337558746 L 27.11959457397461 0.4999994337558746 L 27.11959457397461 12.64504432678223 L 13.4318962097168 24.71607208251953 Z"
          stroke="none"
        />
        <path
          d="M 0.9999942779541016 1 L 0.9999942779541016 12.43603134155273 L 13.44131755828857 24.04110336303711 L 26.61958503723145 12.41933059692383 L 26.61958503723145 1 L 0.9999942779541016 1 M -5.7220458984375e-06 0 L 27.61958503723145 0 L 27.61958503723145 12.87075901031494 L 13.42247486114502 25.39103889465332 L -5.7220458984375e-06 12.87075901031494 L -5.7220458984375e-06 0 Z"
          stroke="none"
          fill="#ddd"
        />
      </g>
      <rect
        id="Rectangle_12496"
        data-name="Rectangle 12496"
        width="20"
        height="2"
        rx="1"
        transform="translate(4058 -698.742)"
        fill="#fff"
      />
      <rect
        id="Rectangle_12497"
        data-name="Rectangle 12497"
        width="20"
        height="2"
        rx="1"
        transform="translate(4058 -690.742)"
        fill="#fff"
      />
      <rect
        id="Rectangle_12498"
        data-name="Rectangle 12498"
        width="20"
        height="2"
        rx="1"
        transform="translate(4058 -694.742)"
        fill="#fff"
      />
    </g>
  </svg>
);
